export const includesIgnoreCase = (var1: string | number, var2: string | number) =>
    String(var1)
        .toLowerCase()
        .includes(String(var2).toLowerCase());
